<script setup lang="ts">
defineProps<{
  open?: boolean
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'afterLeave'): void
}>()
</script>

<template>
  <HTransitionRoot appear :show="open" as="template" @after-leave="emit('afterLeave')">
    <HDialog as="div" class="relative z50" @close="emit('close')">
      <HTransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-slate-900/25" />
      </HTransitionChild>
      <div class="fixed inset-0 overflow-y-auto">
        <div class="min-h-full flex items-center justify-center p4 text-center">
          <HTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <slot />
          </HTransitionChild>
        </div>
      </div>
    </HDialog>
  </HTransitionRoot>
</template>
